import CartaDePorteDescargada from '../../../models/cartaDePorte/carta_de_porte_descargada'

export function saveDetallePdf () {
  return (dispatch) => {
    dispatch({
      type: 'GENERAR_DETALLE_PDF',
      fileDetallePdfOk: false
    })
    dispatch({
      type: 'DETALLE_MERCADERIA',
      data: []
    })
  }
}

export function descargarDetallePdf () {
  return (dispatch, getState) => {
    dispatch({
      type: 'GENERAR_DETALLE_PDF',
      fileDetallePdfOk: true
    })
    dispatch({
      type: 'RELEASE_INTERDICTO_CARTA_DE_PORTE'
    })
  }
}

export function obtenerDetalleMercaderia (cartaDePorteAutomotor, callback) {
  return (dispatch) => {
    return CartaDePorteDescargada.getConsultaCeaTicketDescarga(cartaDePorteAutomotor)
      .then((data) => {
        dispatch({
          type: 'DETALLE_MERCADERIA',
          data: data
        })
        return CartaDePorteDescargada.getInterdictoDeCartaDePorteAutomotor(cartaDePorteAutomotor)
          .then((data) => {
            if (data !== undefined) {
              const hoy = new Date()
              const desde = new Date(data.inicioDeInterdicto)
              const hasta = new Date(data.finDeInterdicto)
              if (desde.valueOf() >= hoy.valueOf() && hasta.valueOf() <= hoy.valueOf()) {
                dispatch({
                  type: 'INTERDICTO_CARTA_DE_PORTE',
                  data: data.acta
                })
              }
            }
          })
      },
      callback && callback())
  }
}
